import { render, staticRenderFns } from "./AccountantReport.vue?vue&type=template&id=2c979c31&"
import script from "./AccountantReport.vue?vue&type=script&lang=js&"
export * from "./AccountantReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports